export const ADD_CTOKEN: string = 'ADD_CTOKEN';
export const ADD_TOTAL_CONTACTS: string = 'ADD_TOTAL_CONTACTS';
export const ADD_DUPLICATES: string = 'ADD_DUPLICATES';
export const ADD_INVALID: string = 'ADD_INVALID';
export const ADD_CNAME: string = 'ADD_CNAME';
export const ADD_CTYPE: string = 'ADD_CTYPE';
export const ADD_RETRY: string = 'ADD_RETRY';
export const ADD_SOUND_TYPE: string = 'ADD_SOUND_TYPE';
export const ADD_SOUND_DURATION_TTS: string = 'ADD_SOUND_DURATION_TTS';
export const ADD_SOUND_DURATION_SEL: string = 'ADD_SOUND_DURATION_SEL';
export const ADD_SOUND_DURATION_UF: string = 'ADD_SOUND_DURATION_UF';
export const ADD_SOUND_ID: string = 'ADD_SOUND_ID';
export const ADD_SOUND_MESSAGE: string = 'ADD_SOUND_MESSAGE';
export const ADD_TOTAL_UNITS: string = 'ADD_TOTAL_UNITS';
export const ADD_SCHEDULE: string = 'ADD_SCHEDULE';
export const ADD_BATCH_SIZE: string = 'ADD_BATCH_SIZE';
export const ADD_SCHEDULE_INTERVAL: string = 'ADD_SCHEDULE_INTERVAL';
export const ADD_ESTIMATED_COST: string = 'ADD_ESTIMATED_COST';
export const ADD_BALANCE_LEFT: string = 'ADD_BALANCE_LEFT';
export const ADD_IS_ALLOWED: string = 'ADD_IS_ALLOWED';
export const ADD_IS_POSTPAID_VC: string = 'ADD_IS_POSTPAID_VC';
export const ADD_TOTAL_CONTACTS_FINAL: string = 'ADD_TOTAL_CONTACTS_FINAL';
export const ADD_TOTAL_CHARGE: string = 'ADD_TOTAL_CHARGE';
export const ADD_TOTAL_DURATION: string = 'ADD_TOTAL_DURATION';
export const ADD_SELECTED_SOUND_ID: string = 'ADD_SELECTED_SOUND_ID';
export const ADD_TTS_FILE_PATH: string = 'ADD_TTS_FILE_PATH';
export const CLEAR_TTS_FILE_PATH: string = 'CLEAR_TTS_FILE_PATH';
export const CLEAR_SOUND_ID: string = 'CLEAR_SOUND_ID';
export const ADD_FLOW_NAME: string = 'ADD_FLOW_NAME';
export const ADD_FLOW_ID: string = 'ADD_FLOW_ID';
export const ADD_MESSAGE_PARAMS: string = 'ADD_MESSAGE_PARAMS';
export const ADD_FILE_COLUMN_NAMES: string = 'ADD_FILE_COLUMN_NAMES';
export const ADD_FILE_SAMPLE_DATA: string = 'ADD_FILE_SAMPLE_DATA';
export const ADD_MOBILE_NUMBER_COLUMN: string = 'ADD_MOBILE_NUMBER_COLUMN';
export const ADD_TOTAL_CONTACTS_OBJECT: string = 'ADD_TOTAL_CONTACTS_OBJECT';
export const ADD_SCHEDULE_LATER: string = 'ADD_SCHEDULE_LATER';
export const ADD_SPLIT_CAMPAIGN: string = 'ADD_SPLIT_CAMPAIGN';
export const ADD_SCHEDULED_DATE: string = 'ADD_SCHEDULED_DATE';
export const ADD_SCHEDULED_TIME: string = 'ADD_SCHEDULED_TIME';
export const ADD_SELECTED_SPEECH_RATE: string = 'ADD_SELECTED_SPEECH_RATE';
export const ADD_SELECTED_LANGUAGE: string = 'ADD_SELECTED_LANGUAGE';
export const ADD_AUDIO_FILE_PATH: string = 'ADD_AUDIO_FILE_PATH';
export const ADD_REPEATED_TITLE: string = 'ADD_REPEATED_TITLE';
export const RESET_STATE: string = 'RESET_STATE';
export const ADD_CURRENT_USAGE: string = 'ADD_CURRENT_USAGE';
export const ADD_SELECTED_FROM_NUMBERS: string = 'ADD_SELECTED_FROM_NUMBERS';

export function addCToken(ctoken: string): IAddCTokenActionType {
	return { type: ADD_CTOKEN, ctoken: ctoken };
}
export function addtotalContacts(
	totalContacts: number
): IAddtotalContactsActionType {
	return { type: ADD_TOTAL_CONTACTS, totalContacts: totalContacts };
}
export function addDuplicates(duplicates: number): IAddDuplicateActionType {
	return { type: ADD_DUPLICATES, duplicates: duplicates };
}
export function addInvalid(invalid: number): IAddInvalidActionType {
	return { type: ADD_INVALID, invalid: invalid };
}
export function addCName(campaignName: string): IAddCNameActionType {
	return { type: ADD_CNAME, campaignName: campaignName };
}
export function addCType(campaignType: string): IAddCTypeActionType {
	return { type: ADD_CTYPE, campaignType: campaignType };
}
export function addRetry(retry: number): IAddRetryActionType {
	return { type: ADD_RETRY, retry: retry };
}
export function addSoundType(soundType: string): IAddSoundTypeActionType {
	return { type: ADD_SOUND_TYPE, soundType: soundType };
}
export function addSoundID(soundID: any): IAddSoundIDActionType {
	return { type: ADD_SOUND_ID, soundID: soundID };
}
export function addSoundMessage(message: any): IAddSoundMessageActionType {
	return { type: ADD_SOUND_MESSAGE, message: message };
}
export function addTotalUnits(totalUnits: any): IAddTotalUnitsActionType {
	return { type: ADD_TOTAL_UNITS, totalUnits: totalUnits };
}
export function addSchedule(schedule: string): IAddScheduleActionType {
	return { type: ADD_SCHEDULE, schedule: schedule };
}
export function addBatchSize(batchSize: number): IAddBatchSizeActionType {
	return { type: ADD_BATCH_SIZE, batchSize: batchSize };
}
export function addScheduleInterval(
	scheduleInterval: number
): IAddScheduleIntervalActionType {
	return { type: ADD_SCHEDULE_INTERVAL, scheduleInterval: scheduleInterval };
}
export function addEstimatedCost(
	estimatedCost: string
): IAddEstimatedCostActionType {
	return { type: ADD_ESTIMATED_COST, estimatedCost: estimatedCost };
}
export function addBalanceLeft(balanceLeft: string): IAddBalanceLeftActionType {
	return { type: ADD_BALANCE_LEFT, balanceLeft: balanceLeft };
}
export function addIsAllowed(isAllowed: number): IAddIsAllowedActionType {
	return { type: ADD_IS_ALLOWED, isAllowed: isAllowed };
}
export function addIsPostpaidVC(
	isPostpaidVC: number
): IAddIsPostpaidVCActionType {
	return { type: ADD_IS_POSTPAID_VC, isPostpaidVC: isPostpaidVC };
}
export function addSoundDurationTTS(
	soundDurationTTS: number
): IAddSoundDurationTTSActionType {
	return { type: ADD_SOUND_DURATION_TTS, soundDurationTTS: soundDurationTTS };
}
export function addSoundDurationSel(
	soundDurationSel: number
): IAddSoundDurationSelActionType {
	return { type: ADD_SOUND_DURATION_SEL, soundDurationSel: soundDurationSel };
}
export function addSoundDurationUF(
	soundDurationUF: number
): IAddSoundDurationUFActionType {
	return { type: ADD_SOUND_DURATION_UF, soundDurationUF: soundDurationUF };
}
export function addTotalContactsFinal(
	totalContactsFinal: number
): IAddTotalContactsFinalActionType {
	return {
		type: ADD_TOTAL_CONTACTS_FINAL,
		totalContactsFinal: totalContactsFinal,
	};
}
export function addTotalCharge(totalCharge: number): IAddTotalChargeActionType {
	return { type: ADD_TOTAL_CHARGE, totalCharge: totalCharge };
}
export function addTotalDuration(
	totalDuration: number
): IAddTotalDurationActionType {
	return { type: ADD_TOTAL_DURATION, totalDuration: totalDuration };
}
export function addSelectedSoundId(
	selectedSoundId: number
): IAddSelectedSoundIdActionType {
	return { type: ADD_SELECTED_SOUND_ID, selectedSoundId: selectedSoundId };
}
export function addTTSFilePath(TTSFilePath: string): IAddTTSFilePathActionType {
	return { type: ADD_TTS_FILE_PATH, TTSFilePath: TTSFilePath };
}
export function clearTTSFilePath(
	TTSFilePath: string
): IClearTTSFilePathActionType {
	return { type: CLEAR_TTS_FILE_PATH, TTSFilePath: TTSFilePath };
}
export function clearSoundID(): IClearSoundIDActionType {
	return { type: CLEAR_SOUND_ID };
}
export function addFlowName(flowName: string): IAddFlowNameActionType {
	return { type: ADD_FLOW_NAME, flowName: flowName };
}
export function addFlowId(flowId: string): IAddFlowIdActionType {
	return { type: ADD_FLOW_ID, flowId: flowId };
}
export function addMessageParams(
	messageParams: Record<any, any>
): IAddMessageParamsActionType {
	return { type: ADD_MESSAGE_PARAMS, messageParams: messageParams };
}
export function addFileColumnNames(
	fileColumnNames: Record<any, any>
): IAddFileColumnsNamesActionType {
	return { type: ADD_FILE_COLUMN_NAMES, fileColumnNames: fileColumnNames };
}
export function addFileSampleData(
	fileSampleData: Record<any, any>
): IAddFileSampleDataActionType {
	return { type: ADD_FILE_SAMPLE_DATA, fileSampleData: fileSampleData };
}
export function addMobileNumberField(
	mobileNumberColumn: string
): IAddMobileNumberColumn {
	return {
		type: ADD_MOBILE_NUMBER_COLUMN,
		mobileNumberColumn: mobileNumberColumn,
	};
}
export function addTotalContactObject(
	totalContactsObject: Record<any, any>
): IAddTotalContactsObjectActionType {
	return {
		type: ADD_TOTAL_CONTACTS_OBJECT,
		totalContactsObject: totalContactsObject,
	};
}

export function addSplitCampaign(splitCampaign: boolean): IAddSplitCampaign {
	return {
		type: ADD_SPLIT_CAMPAIGN,
		splitCampaign: splitCampaign,
	};
}

export function addScheduleLater(scheduleLater: boolean): IAddScheduleLater {
	return {
		type: ADD_SCHEDULE_LATER,
		scheduleLater: scheduleLater,
	};
}

export function addScheduledDate(scheduledDate: any): IAddScheduleDate {
	return {
		type: ADD_SCHEDULED_DATE,
		scheduledDate: scheduledDate,
	};
}

export function addScheduledTime(scheduledTime: any): IAddScheduleTime {
	return {
		type: ADD_SCHEDULED_TIME,
		scheduledTime: scheduledTime,
	};
}

export function addSelectedSpeechRate(
	speechRate: string
): IAddSelectedSpeechRate {
	return {
		type: ADD_SELECTED_SPEECH_RATE,
		speechRate: speechRate,
	};
}

export function addSelectedLanguage(language: string): IAddSelectedLanguage {
	return {
		type: ADD_SELECTED_LANGUAGE,
		language: language,
	};
}

export function addAudioFilePath(
	audioFilePath: string
): IAddSelectedAudioFilePath {
	return {
		type: ADD_AUDIO_FILE_PATH,
		audioFilePath: audioFilePath,
	};
}

export function addRepeatedTitle(
	repeatedTitle: string | undefined
): IAddRepeatedTitle {
	return {
		type: ADD_REPEATED_TITLE,
		repeatedTitle: repeatedTitle,
	};
}

export function resetState(): IResetState {
	return {
		type: RESET_STATE,
	};
}

export function addCurrentUsage(
	currentUsage: number,
	dailyLimit: number
): IAddCurrentUsage {
	return {
		type: ADD_CURRENT_USAGE,
		currentUsage: currentUsage,
		dailyLimit: dailyLimit,
	};
}

export function addFromNumbers(fromNumbers: any): IAddSelectedFromNumbers {
	return {
		type: ADD_SELECTED_FROM_NUMBERS,
		fromNumbers: fromNumbers,
	};
}

interface IAddCTokenActionType {
	type: string;
	ctoken: string;
}
interface IAddtotalContactsActionType {
	type: string;
	totalContacts: number;
}
interface IAddDuplicateActionType {
	type: string;
	duplicates: number;
}
interface IAddInvalidActionType {
	type: string;
	invalid: number;
}
interface IAddCNameActionType {
	type: string;
	campaignName: string;
}
interface IAddCTypeActionType {
	type: string;
	campaignType: string;
}
interface IAddRetryActionType {
	type: string;
	retry: number;
}
interface IAddSoundTypeActionType {
	type: string;
	soundType: string;
}
interface IAddSoundIDActionType {
	type: string;
	soundID: any;
}
interface IAddSoundMessageActionType {
	type: string;
	message: any;
}
interface IAddTotalUnitsActionType {
	type: string;
	totalUnits: any;
}
interface IAddScheduleActionType {
	type: string;
	schedule: string;
}
interface IAddBatchSizeActionType {
	type: string;
	batchSize: number;
}
interface IAddScheduleIntervalActionType {
	type: string;
	scheduleInterval: number;
}
interface IAddEstimatedCostActionType {
	type: string;
	estimatedCost: string;
}
interface IAddBalanceLeftActionType {
	type: string;
	balanceLeft: string;
}
interface IAddIsAllowedActionType {
	type: string;
	isAllowed: number;
}
interface IAddIsPostpaidVCActionType {
	type: string;
	isPostpaidVC: number;
}
interface IAddSoundDurationTTSActionType {
	type: string;
	soundDurationTTS: number;
}
interface IAddSoundDurationSelActionType {
	type: string;
	soundDurationSel: number;
}
interface IAddSoundDurationUFActionType {
	type: string;
	soundDurationUF: number;
}
interface IAddTotalContactsFinalActionType {
	type: string;
	totalContactsFinal: number;
}
interface IAddTotalChargeActionType {
	type: string;
	totalCharge: number;
}
interface IAddTotalDurationActionType {
	type: string;
	totalDuration: number;
}
interface IAddSelectedSoundIdActionType {
	type: string;
	selectedSoundId: number;
}
interface IAddTTSFilePathActionType {
	type: string;
	TTSFilePath: string;
}
interface IClearTTSFilePathActionType {
	type: string;
	TTSFilePath: string;
}
interface IClearSoundIDActionType {
	type: string;
}
interface IAddFlowNameActionType {
	type: string;
	flowName: string;
}
interface IAddFlowIdActionType {
	type: string;
	flowId: string;
}
interface IAddMessageParamsActionType {
	type: string;
	messageParams: Record<any, any>;
}
interface IAddTotalContactsObjectActionType {
	type: string;
	totalContactsObject: Record<any, any>;
}
interface IAddFileColumnsNamesActionType {
	type: string;
	fileColumnNames: Record<any, any>;
}
interface IAddFileSampleDataActionType {
	type: string;
	fileSampleData: Record<any, any>;
}
interface IAddMobileNumberColumn {
	type: string;
	mobileNumberColumn: string;
}

interface IAddSplitCampaign {
	type: string;
	splitCampaign: boolean;
}

interface IAddScheduleLater {
	type: string;
	scheduleLater: boolean;
}

interface IAddScheduleDate {
	type: string;
	scheduledDate: boolean;
}

interface IAddScheduleTime {
	type: string;
	scheduledTime: boolean;
}

interface IAddSelectedSpeechRate {
	type: string;
	speechRate: string;
}

interface IAddSelectedLanguage {
	type: string;
	language: string;
}

interface IAddSelectedAudioFilePath {
	type: string;
	audioFilePath: string;
}

interface IAddRepeatedTitle {
	type: string;
	repeatedTitle: string | undefined;
}
interface IResetState {
	type: string;
}

interface IAddCurrentUsage {
	type: string;
	currentUsage: number;
	dailyLimit: number;
}

interface IAddSelectedFromNumbers {
	type: string;
	fromNumbers: any;
}